import { ModalTypes } from '../../constants';
import { ModalParams } from '../../interface';

import { GlobalStore, key, ModalsType } from './types';

export const localGetModalType = (store: ModalsType): ModalTypes | undefined => store?.modalType;
export const getModalType = (store: GlobalStore): ModalTypes | undefined => localGetModalType(store[key]);

export const localGetParams = (store: ModalsType): ModalParams | undefined => store?.params;
export const getParams = (store: GlobalStore): ModalParams | undefined => localGetParams(store[key]);

export const localGetIsOpen = (store: ModalsType): boolean => store.isOpen;
export const getIsOpen = (store: GlobalStore): boolean => localGetIsOpen(store[key]);
